import React from 'react';
import { ReviewCaseDetails } from 'pages/components';

const ContactNewCaseReview = (props) => (
  <ReviewCaseDetails {...props} />
);

export default ContactNewCaseReview;
